import { formatDateRange } from '../../../../ts-utils/date-utils'
import type { SuspensionStatus } from './playerStatus'

/**
 * The date line under a suspension's pill, e.g. "Sep 1 – Oct 1, 2026", or
 * "Sep 1, 2026 – Indefinitely" when it has no fixed end.
 *
 * Suspension dates are calendar dates, so `formatDateRange` reads them in UTC —
 * the viewer's zone must not move a suspension onto the previous day.
 * `indefiniteLabel` is passed in already translated; `common/` does no i18n.
 *
 * Empty when the suspension has no start date.
 */
export const formatSuspensionDates = (
  status: SuspensionStatus,
  indefiniteLabel: string
): string => {
  if (status.isIndefinite) {
    const start = formatDateRange(status.startDate, null)
    return start ? `${start} – ${indefiniteLabel}` : ''
  }
  return formatDateRange(status.startDate, status.endDate)
}
